export enum PermissionType {
    digital = 1,
    physical = 2,
    crypto = 3
}

export enum PermissionView {
    include = 1,
    exclude = 2
}